import { ApolloClient, InMemoryCache, createHttpLink } from '@apollo/client';
import { setContext } from '@apollo/client/link/context';
import { GATEWAY_API_URL } from '@admin-panel/config/env';
import { getDeviceFingerprint } from '@admin-panel/utils';

const httpLink = createHttpLink({
  uri: `${GATEWAY_API_URL}/shopify-admin`,
});

const authLink = setContext((_, { headers }) => {
  const token = localStorage.getItem('at');
  const refreshToken = localStorage.getItem('rt');

  return {
    headers: {
      ...headers,
      Authorization: token ? `Bearer ${token}` : '',
      'x-lk-refresh-token': refreshToken || '',
      'x-lk-deviceid': getDeviceFingerprint(),
      'x-lk-portalcode': 'erp',
      'x-lk-app': 'foundation',
    },
  };
});

export const shopifyApolloClient = new ApolloClient({
  link: authLink.concat(httpLink),
  cache: new InMemoryCache(),
});
